const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'CMP_CODE_QUERY_PARAMS_AMEX_CARD':
      return { ...state, cmpCodeQueryParams: action.data };
    case 'TOGGLE_LOADING_SPINNER':
      return { ...state, toggleLoadingSpinner: action.data };
    case 'SAVE_GLOBAL_SESSION_VALUES':
      return { ...state, globalSessionValues: action.data };
    case 'SAVE_APIGEE_TOKEN':
      return { ...state, apigeeAccessToken: action.data };
    case 'SAVE_ZIPCODE_LIST':
      return { ...state, zipcodeSuggestionList: action.data };
    case 'SAVE_ZIPCODE_ENTERED_BY_USER':
      return {
        ...state, zipcodeEnteredByUser: action.data, selectedZipcode: "", streetTermEnteredByUser: "", unitList: "",
        selectedUnit: "", enableCheckAvailability: true, enableCheckAvailabilityBtn: false, phoneNumber: "", emailAddress: "", addressQualificationDetails: "",
        isExistingCustomer: false, selectedStreetAddress: "", previousAddressID: ""
      };
    case 'SAVE_ZIPCODE_ENTERED_BY_USER_ONLY':
      return {
        ...state, zipcodeEnteredByUser: action.data
      };
    case 'SAVE_SELECTED_ZIPCODE':
      return { ...state, selectedZipcode: action.data, zipcodeEnteredByUser: action.data.zip, zipcodeSuggestionList: "", streetAddressSuggestionList: "", selectedStreetAddress: "" };
    case 'SAVE_SELECTED_ZIPCODE_ONLY':
      return { ...state, selectedZipcode: action.data, zipcodeEnteredByUser: action.data.zip };
    case 'SAVE_IS_ZIP_FIOS_QUALIFIED':
      return { ...state, isFiosQualified: action.data };
    case 'SAVE_STREET_TERM_ENTERED_BY_USER':
      return { ...state, streetTermEnteredByUser: action.data, selectedStreetAddress: "", unitList: "", selectedUnit: "", enableCheckAvailability: true, enableCheckAvailabilityBtn: false, emptyUnitsError: false, lqStreetAddrError: "" };
    case 'SAVE_STREET_ADDRESS_LIST':
      return { ...state, streetAddressSuggestionList: action.data, emptyUnitsError: false, lqStreetAddrError: "" };
    case 'SAVE_SELECTED_STREET_ADDRESS':
      return { ...state, selectedStreetAddress: action.data,billingselectedStreetAddress: action.data, streetTermEnteredByUser: action?.data?.disprawstr || '', streetAddressSuggestionList: "", emptyUnitsError: false };
      case 'SAVE_DEFAULT_ADDRESS':{
        return { ...state, defaultSteetAddress :action.data.defaultSteetAddress,defaultSelectUnit :action.data.defaultSelectUnit,defaultUnitList :action.data.defaultUnitList}
      }
    case 'SAVE_UNIT_LIST':
      return { ...state, unitList: action.data,billingunitList:action.data, emptyUnitsError: false };
      case 'SAVE_UNITS_BILLING_ADDRESS':
        return { ...state, unitList: action.data,billingunitList:action.data, emptyUnitsError: false };
    case 'SAVE_TOTAL_UNITS':
      return { ...state, totalUnits: action.data, emptyUnitsError: false };
    case 'SAVE_SELECTED_UNIT':
      return { ...state, selectedUnit: action.data,biilingselectedUnit:action.data, emptyUnitsError: false }
    case 'ENABLE_CHECK_AVAILABILITY':
      return { ...state, enableCheckAvailability: true };
    case 'SAVE_PHONE_NUMBER':
      return { ...state, phoneNumber: action.data };
    case 'SAVE_PRICE_QUOTE_NUMBER':
      return { ...state, priceQuoteNumber: action.data };
    case "SAVE_OPTIX_MON_NUMBER":
      return { ...state, optixMonNumber: action.data };
    case 'SAVE_OPTIX_SESSION_ID':
      return { ...state, optixSessionId: action.data };
    case 'SAVE_EMAIL_ADDRESS':
      return { ...state, emailAddress: action.data };
    case 'SAVE_ADDRESS_QUALIFICATION_DETAILS':
      return { ...state, addressQualificationDetails: action.data }
    case 'DO_LOOP_TRIGGERED':
      return { ...state, doLoopTriggered: action.data }
    case 'SAVE_OPTIX_ADDRESS_QUALIFICATION_DETAILS':
      return { ...state, optixAddressQualificationDetails: action.data }
    case 'SAVE_JOINT_OFFER_DETAILS':
      return {
        ...state, JointOfferPrice: action.data.JointOfferPrice,
        JointOfferStatus: action.data.JointOfferStatus,
        OneGigSpeedPrice: action.data.OneGigSpeedPrice
      }
    case 'JOINT_OFFER_ATTEMPTED':
      return {
        ...state, isJointOfferAttempted: action.data
      }
    case 'SKIP_OPTIX_FLOW_DUE_TO_API_FAILURE':
      return { ...state, skipOptixFlowDueToApiFailure: action.data }
    case 'DISABLE_CHECK_AVAILABILITY':
      return { ...state, enableCheckAvailability: false };
    case 'DISABLE_CHECK_AVAILABILITY_BUTTON':
      return { ...state, enableCheckAvailabilityBtn: true };
    case 'ENABLE_CHECK_AVAILABILITY_BUTTON':
      return { ...state, enableCheckAvailabilityBtn: false };
    case 'TOGGLE_GLOBAL_ERROR_MESSAGE':
      return { ...state, toggleGlobalErrorMessage: action.data };
    case 'IS_EXISTING_CUSTOMER':
      return { ...state, isExistingCustomer: action.data };
    case 'HAS_PENDING_ORDER':
      return { ...state, hasPendingOrder: action.data };
    case 'SET_PENDING_ORDER_RESPONSE':
      return { ...state, hasPendingOrderResponse: action.data };
    case 'PENDING_ORDER_RESPONSE_INPROGRESS':
      return { ...state, pendingOrderResponseInProgress: action.data };

    case 'HAS_MULTIPLE_ADDRESS':
      return { ...state, hasMultipleAddress: action.data };
    case 'SAVE_FAQ_CONTENT':
      return { ...state, faqContent: action.data };
    case 'CLEAR_FAQ_CONTENT':
      return { ...state, faqContent: '' };
    case 'SET_CONV_INFO':
      console.log('isChatInitiated  setConvId', action.data)
      return { ...state, latestConvId: action.data };
    case 'SET_BANNER_INFO':
      return { ...state, bannerInfo: action.data };
    case 'SET_APPLICABLE_BUNDLE':
      return { ...state, applicableBundle: action.data };
    case 'SET_NEW_ADDRESS_FLOW':
      return { ...state, isNewAddressFlow: action.data };
    case 'SET_PREVIOUS_ADDRESS_ID':
      return { ...state, previousAddressID: action.data };
    case 'SET_PREVIOUS_HAS_EXISTING_SERVICE':
      return { ...state, previousHasExistingService: action.data };
    case 'SET_ADDRESS_INFO':
      return { ...action.data };
    case 'RESET_DOLOOP_FLAGS': {
      return { ...state, isExistingCustomer: false, enableCheckAvailability: true, enableCheckAvailabilityBtn: false, hasMultipleAddress: false, addressQualificationDetails: "", optixAddressQualificationDetails: undefined };
    }
    case 'RESET_CHECKOUT_FLAGS': {
      return { ...state, isExistingCustomer: false, enableCheckAvailability: true, enableCheckAvailabilityBtn: false, hasMultipleAddress: false };
    }
    case 'SET_UNITS_TRIGGERED': {
      return { ...state, unitsTriggered: action.data };
    }
    case 'SET_UNITS_RESPONDED': {
      return { ...state, unitsResponded: action.data };
    }
    case 'SET_EMPTY_UNITS_ERROR': {
      return { ...state, emptyUnitsError: action.data };
    }
    case 'SET_BASE_ADDR_UNIT_ERROR': {
      return { ...state, baseAddrUnitError: action.data };
    }
    case 'SET_DONT_SHOW_LIVE_UNIT': {
      return { ...state, iDontLiveUnit: action.data };
    }
    case 'SET_CHECKAVAILABILITY_CLICKED': {
      return { ...state, chkAvailibtyClicked: action.data };
    }
    case 'SET_STREETADDR_ERROR': {
      return { ...state, lqStreetAddrError: action.data };
    }
    case 'SAVE_VO_STATUS': {
      return { ...state, VOStatus: action.data };
    }
    case "SAVE_CHECKAVAIL_RES": {
      return { ...state, checkAvailResponse: action.data };
    }
    case 'SET_AB_LOGIC_RESP':
      return { ...state, getABLogicResp: action.data };
    case 'SAVE_AD_RESPONSE': {
      return { ...state, lqPageAds: action.data };
    }
    case 'SET_BUSINESS_SOLUTION_LOGIC':
      return { ...state, getBizSolutionLogic: action.data };
    case 'SET_IS_EXTERNALAPP_REDIRECT':
      return { ...state, isExternalAppRedirect: action.data };
    case 'SAVE_CITY_AND_STATE':
      return { ...state, selectedZipcode: action.data }
    case 'SET_VAS_DISPLAY_RESP':
      return { ...state, getVasDisplayResp: action.data };
    case 'SET_REDIRECT_FROM':
        return { ...state, redirectedFrom: action.data };
    case 'SET_LQ_QUALIFICATION_RESPONSE':
        return { ...state, lqQualificationDetails: action.data };    
    default:
      return state;
  }
};
export default reducer;
